<template>
  <div class="content">
    <!-- 面包屑 -->
    <!-- <div class="breadcrumb">
      <i class="iconfont icondqwz"></i>
      <ul>
        <li class="active">方案配置</li>
      </ul>
    </div> -->
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 告警方案配置
        </span>
        <div class="w_normalNav" :parent="self">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="GreenSmBtn" @click="addnew">新增</button>
        </div>
        <div class="searchForm1">
          <!-- <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl"></searchForm> -->
          <el-form ref="seefrom" class="uLabelDcontent" :model="seefrom">
            <el-form-item label="方案名称">
              <el-input placeholder="请输入方案名称" v-model="seefrom.name"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <easyTable
            apiUrl="operation/findAllAlarmReport"
            :parent="self"
            :config="config"
            :other="other"
            ref="alarm"
          >
            <template slot="last">
              <el-table-column label="操作" width="500" align="center">
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont iconcheck"
                    type="text"
                    size="small"
                    @click="see(scope.$index,  scope.row)"
                  >查看</el-link>
                  <el-link
                    icon="iconfont iconedit"
                    type="text"
                    size="small"
                    @click="edit(scope.$index,  scope.row)"
                  >编辑</el-link>
                  <el-link
                    icon="iconfont icondelete"
                    type="text"
                    size="small"
                    @click="deleteMsg(scope.$index,  scope.row)"
                  >删除</el-link>
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
        <!-- <el-dialog class="editDialog" title="修改用户信息" :visible.sync="editDialogVisible">
          <searchForm :items="items"></searchForm>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="editDialogVisible = false">取消</el-button>
            <el-button class="confirmButton" type="primary" @click="editDialogVisible = false">确定</el-button>
          </div>
        </el-dialog>-->
        <el-dialog
          class="editDialog"
          :visible.sync="displayForm"
          :title="title"
          :close-on-click-modal="false"
          @open="closedialog"
        >
          <el-form ref="addEquipment" :model="addEquipment" :disabled="!seeBtn" :rules="rules">
            <el-form-item label="方案名称：" prop="name">
              <el-input v-model="addEquipment.name"></el-input>
            </el-form-item>

            <el-form-item label="通知方式：" prop="method">
              <el-checkbox-group v-model="addEquipment.method">
                <el-checkbox
                  v-for="item in groups"
                  :label="item.value"
                  :key="item.name"
                >{{item.name}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="通知人员：" prop="privacy">
              <div class="notice_person">
                <el-form :model="addEquipment" ref="c_add" :disabled="!seeBtn">
                <el-form-item label="默认用户组：" prop="privacy">
                  <el-checkbox v-model="addEquipment.privacy">设备安装点默认用户组</el-checkbox>
                </el-form-item>

                <el-form-item label="指定用户：" prop="user">
                  <el-select
                    v-model="addEquipment.user"
                    multiple
                    filterable
                    default-first-option
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in users"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="指定用户组：" prop="usergroup" style="margin-top:20px">
                  <el-select
                    v-model="addEquipment.usergroup"
                    multiple
                    filterable
                    default-first-option
                    placeholder="请选择"
                    style="width:auto;"
                  >
                    <el-option
                      v-for="item in usergroups"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              </div>

            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer" v-if="seeBtn">
            <el-button class="cancelButton" @click="displayForm = false">取 消</el-button>
            <el-button class="confirmButton" type="primary" @click="submitAdd">确 定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { dt, obj2urlsp } from "utils";

export default {
  data() {
    return {
      rules: {
        name: [{ required: true, message: "请输入方案名称", trigger: "blur" }],
      },
      loading: true,
      title: "",
      tabName: "jsgl",
      showTable: true,
      other: {},
      users: [],
      groups: [],
      usergroups: [],
      seeBtn: null,
      displayForm: false,
      seefrom: {
        t_name: "",
        startTime: "",
        endTime: ""
      },
      addEquipment: {
        name: "",
        method: [],
        privacy: false,
        user: [],
        usergroup: []
      }
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "name",
          label: "方案名称"
        }
        // {
        //   prop: (row, column) => row.oildrum.rfid_number + row.oildrum.imei,
        //   label: "随便"
        // }
      ];
    },
    dt() {
      return dt.map(({ label }) => label);
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable")
  },
  methods: {
    //搜索
    subSeefrom() {
      this.other = this.seefrom;
      this.$nextTick(this.$refs.alarm.getData);
    },
    //重置
    reset() {
      this.seefrom.name = "";
    },

    closedialog() {
      this.$nextTick(() => {
        this.$refs.addEquipment.resetFields();
      });
    },

    //新增
    addnew() {
      this.addEquipment.user = [];
      this.addEquipment.usergroup = [];
      this.addEquipment.method = [];
      this.addEquipment.privacy = false;
      this.addEquipment.name = "";
      this.title = "新增方案";
      this.state = 1;
      this.displayForm = true;
      this.seeBtn = true;
      if (this.$refs["addEquipment"])
        this.$refs["addEquipment"].clearValidate();
    },
    //查看
    see(index, row) {
      this.title = "查看方案";
      this.displayForm = true;
      this.addEquipment.user = [];
      this.addEquipment.usergroup = [];
      this.addEquipment.method = [];
      this.seeBtn = false;
      this.$axiosget("operation/findAlarmReport", {
        params: {
          id: row.id
        }
      }).then(res => {
        if (res.data.status === "10000") {
          if (res.data.data.user) {
            this.options = res.data.data.user.split(",");
            this.options.forEach(item => {
              this.addEquipment.user.push(parseInt(item));
            });
          }
          if (res.data.data.usergroup) {
            this.addEquipment.options = res.data.data.usergroup.split(",");
            this.addEquipment.options.forEach(item => {
              this.addEquipment.usergroup.push(parseInt(item));
            });
          }
          this.addEquipment.method = res.data.data.method.split(",");
          this.addEquipment.privacy = res.data.data.privacy;
          if (this.addEquipment.privacy == "1") {
            this.addEquipment.privacy = true;
          } else if (this.addEquipment.privacy == "0") {
            this.addEquipment.privacy = false;
          }
          this.addEquipment.name = res.data.data.name;
          this.seeBtn = false;
        }
      });
      if (this.$refs["addEquipment"])
        this.$refs["addEquipment"].clearValidate();
    },
    //编辑
    edit(index, row) {
      this.title = "修改方案";
      this.displayForm = true;
      this.seeBtn = true;
      this.state = 2;

      this.id = row.id;
      this.addEquipment.user = [];
      this.addEquipment.usergroup = [];
      this.addEquipment.method = [];
      this.$axiosget("operation/findAlarmReport", {
        params: {
          id: row.id
        }
      }).then(res => {
        if (res.data.status === "10000") {
          if (res.data.data.user) {
            this.options = res.data.data.user.split(",");
            this.options.forEach(item => {
              this.addEquipment.user.push(parseInt(item));
            });
          }
          if (res.data.data.usergroup) {
            this.addEquipment.options = res.data.data.usergroup.split(",");
            this.addEquipment.options.forEach(item => {
              this.addEquipment.usergroup.push(parseInt(item));
            });
          }
          this.addEquipment.method = res.data.data.method.split(",");
          this.addEquipment.privacy = res.data.data.privacy;
          if (this.addEquipment.privacy == "0") {
            this.addEquipment.privacy = false;
          } else if (this.addEquipment.privacy == "1") {
            this.addEquipment.privacy = true;
          }
          this.addEquipment.name = res.data.data.name;
        }
      });
      if (this.$refs["addEquipment"])
        this.$refs["addEquipment"].clearValidate();
    },
    //确认
    submitAdd() {
      this.$refs.addEquipment.validate(valid => {
        if (valid) {
          if (
            this.addEquipment.privacy !== false ||
            this.addEquipment.user.length !== 0 ||
            this.addEquipment.usergroup.length !== 0
          ) {
            let num = this.addEquipment.method.join();
            let num2 = this.addEquipment.user.join();
            let num3 = this.addEquipment.usergroup.join();
            if (this.addEquipment.privacy) {
              this.addEquipment.privacy = "1";
            } else {
              this.addEquipment.privacy = "0";
            }
            if (this.state === 1) {
              this.$axiospost("operation/addAlarmReport", {
                method: num,
                user: num2,
                usergroup: num3,
                name: this.addEquipment.name,
                privacy: this.addEquipment.privacy
              }).then(res => {
                if (res.data.status === "10000") {
                  this.displayForm = false;

                  this.subSeefrom();
                  let loading = Loading.service({});
                  loading.close();
                }
              });
            } else if (this.state === 2) {
              this.$axiospost("operation/updateAlarmReport", {
                id: this.id,
                method: num,
                user: num2,
                usergroup: num3,
                name: this.addEquipment.name,
                privacy: this.addEquipment.privacy
              }).then(res => {
                if (res.data.status === "10000") {
                  this.displayForm = false;
                  this.subSeefrom();
                }
              });
            }
          } else {
            this.$message.warning("至少选择一种通知人员的方式");
          }
        }
      });
    },
    //删除
    deleteMsg(index, row) {
      var params = new URLSearchParams();
      params.append("id", row.id);
      this.$confirm("是否删除该告警方案?", "删除操作", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$axiospost("operation/deleteAlarmReport", params).then(res => {
          if (res.data.status === "10000") {
            this.subSeefrom();
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          }
        });
      });
    }
  },
  created() {
    this.$axiosget("operation/dictionaryType/queryByKey", {
      params: {
        key: 'handleWay'
      }
    }).then(res => {
      if (true) {
        this.groups = res.data.data.list;
      }
    });

    this.$axiosget("operation/group/findAllList").then(res => {
      if (true) {
        this.usergroups = res.data.data;
      }
    });

    this.$axiosget("manager/company/getCompanUserListByCompanyId", {
      params: {
        companyId: localStorage.getItem("companyId")
      }
    }).then(res => {
      if (res.data.status === 10000) {
        this.users = res.data.data;
      }
    });
  }
};
</script>

<style lang="less">
.w_normalNav{
  padding-top: 10px;
}
  .notice_person {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/configuration/alarm.vue